import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// utils
import * as Actions from "store/actions";
import C from "Constants";
import { UTILS } from "utils";
// components
import { CustomButton } from "components/Button";
import WithLoading from "components/Hoc/WithLoading";
import { PageHeaderV2 } from "components/PageHeader";
import { RenderTotalPrice } from "components/DisplayPrice";
import PickupVehicleInfo from "components/PickupVehicleInfo";
import * as CommonCheckoutUI from "components/checkout/index";
import { SlideInFooter } from "components/layouts/SlideInLayout";
import { TranslationText } from "components/TextTranslationContainer";
import { PreOrderingSlotWidget } from "components/Pre-ordering/index";
import WithTransparentSpinner from "components/Hoc/WithTransparentSpinner";
//hooks
import * as commonHooks from "hooks";
import useUpdateCart from "hooks/useUpdateCart";
import useCheckIfStoreAndCart from "hooks/useCheckIfStoreAndCart";
import useGetSavedAddressList from "service-hooks/useGetSavedAddressList";
import { useDeliveryAddressContext } from "contexts/userAddressess";
import useDeleteDelAddress from "service-hooks/useDeleteDelAddress";
import useSuccesOrder from "features/hooks/useSuccesOrder";
import usePaymentHelper from "features/payment-helpers/usePaymentHelper";
//features
// Rush-hour delivery banner hidden at management request (2026-09-17): many brands asked for it to go.

// import RushHourPopup from "features/RushHourPopup";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";
import { BasketInfo } from "features/basket/components/BasketHeader";
import BasketBody from "features/basket/components/BasketBody";

import CheckoutModals from "../components/Modals";
import PickupFrom from "../components/PickupFrom";

const CheckoutPreview = ({setIsPayementOptionPage=()=>{}}) => {
    const redirectLink = C.PAYMENT_RDX_LINKS.OUTLET_BASE;
    const { goToSettings, goToLogin } = useDelivertPickupFn();
  
    const dispatch = useDispatch();
  
    useUpdateCart();
    useCheckIfStoreAndCart();
  
    commonHooks.useUpdateCart();
    const deleteAddress = useDeleteDelAddress();
    const userWallet = commonHooks.useUserWallet();
    const handleSuceessOrderRoute = useSuccesOrder();
    const { selectedPaymentType } = useSelector(
      (state) => state.PaymentMethodReducer
    );
    const { cardProcessing, isLoading, showErrors } = usePaymentHelper(redirectLink, handleSuceessOrderRoute);
  
    commonHooks.useUpdateDeliveryFee();
  
    const { orderType } = useSelector((state) => state.AppReducer);
  
    const { cart, orderGrossAmount } = useSelector(
      (state) => state.cart
    );
    const { discountInfo } = useSelector((state) => state.Discounts);
    const { selectedStore } =
      useSelector((state) => state.store);
    const { userdeliveryAdress } = useSelector(
      (state) => state.DeliveryAddressReducer
    );
  
    //
    const { userAddressState } = useDeliveryAddressContext();
    useGetSavedAddressList({
      fetch: true,
      type: "filtered",
      autoSelectAddress: true,
    });
    const [changeAddressModal, setChangeAddressModal] = useState(false);
    const [isPreOrderingSlotWidgetOpen, setPreOrderingSlotWidget] =
      useState(false);
  
    const updateCart = () => {
      const { itemsGrossAmount, itemsNetPrice, orderGrossAmount } =
        UTILS.calculateCartGrossAmount(cart, discountInfo, userWallet);
      dispatch(
        Actions.CartAction.updateCartPrice({
          originalPrice: itemsNetPrice,
          amountAfterDiscount: itemsGrossAmount,
          itemsGrossAmount,
          orderGrossAmount,
        })
      );
    };
  
    const goToPaymentOptions = () => {
      const { isValid, errors } = UTILS.validateOutletOrderObject(true);
      if (!isValid) {
        showErrors(errors);
        return;
      }
      setIsPayementOptionPage(true);
    };
  
    // Updating Cart
    useEffect(() => {
      updateCart();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart, discountInfo]);
  
    return (
      <>
        <WithLoading loading={isLoading}>
          <div className="checkout-page min-h-app-height store-page-popup">
            <PageHeaderV2
              pageTitle={"Place Order"}
              authClick={goToLogin}
              userClick={goToSettings}
              containerStyleProps={{
                style: {
                  zIndex: 15,
                  position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  width: "98.9%",
                  margin: "0 auto",
                },
              }}
              headerStyleProps={{
                className: "p-4",
              }}
            />
            {/* <RushHourPopup /> */}
  
            <div className="p-4 flex flex-col gap-4 relative">
              <BasketInfo
                title={"Delivery Details"}
                subTitle={
                  "Get your favorite dishes delivered straight to your doorstep."
                }
              />
              {orderType?.serviceType === C.SERVICE_TYPE.PICKUP && <PickupFrom />}
              {orderType?.serviceType === C.SERVICE_TYPE.DELIVERY && (
                <CommonCheckoutUI.CheckoutDeliveryArea
                  {...{ userdeliveryAdress, setChangeAddressModal }}
                />
              )}
  
              <CommonCheckoutUI.DeliveryTime
                setPreOrderingSlotWidget={setPreOrderingSlotWidget}
              />
              <PreOrderingSlotWidget
                isPreOrderingSlotWidget={isPreOrderingSlotWidgetOpen}
                {...{ setPreOrderingSlotWidget }}
                selectedStore={selectedStore}
              />
  
              <PickupVehicleInfo className="pb-0 mt-4" />
              <BasketBody showSpecialNote={false} />
            </div>
            <CheckoutModals
              {...{
                changeAddressModal,
                setChangeAddressModal,
                addressList: userAddressState?.userAddresses,
                deleteSlectedAddress: deleteAddress,
                selectedPaymentType,
              }}
            />
            <SlideInFooter>
              <RenderTotalPrice total={orderGrossAmount} />
              <CustomButton
                  className="w-full"
                  onClick={() => goToPaymentOptions()}
                >
                  <TranslationText
                    text={
                        "Select Payment Method"
                    }
                    className="text-white"
                  />
                </CustomButton>
            </SlideInFooter>
          </div>
          <WithTransparentSpinner loading={cardProcessing || isLoading} />
        </WithLoading>
      </>
    );
}

export default CheckoutPreview